import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef
} from '@angular/core';

import {of, Observable, Subject} from 'rxjs';

import {toBoolean} from '../core/convert';

import {TransferCanMove, TransferChange, TransferItem, TransferSearchChange, TransferSelectChange} from './interface';

@Component({
  selector: 'jd-transfer',
  preserveWhitespaces: false,
  templateUrl: './transfer.component.html',
  host: {
    '[class.ant-transfer]': 'true'
  }
})
export class JdTransferComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  // tslint:disable-next-line:no-any
  locale: any = {};
  private _showSearch = false;

  leftFilter = '';
  rightFilter = '';
  // left
  leftDataSource: TransferItem[] = [];

  // right
  rightDataSource: TransferItem[] = [];
  leftActive = false;
  rightActive = false;
  // region: fields

  @Input() jdDataSource: TransferItem[] = [];
  @Input() jdTitles: string[] = ['', ''];
  @Input() jdOperations: string[] = [];
  @Input() jdListStyle: object;
  @Input() jdItemUnit = 'é¡¹';
  @Input() jdItemsUnit = 'é¡¹';
  @Input() jdRender: TemplateRef<void>;
  @Input() jdFooter: TemplateRef<void>;
  @Input() jdFilterOption: (inputValue: string, item: TransferItem) => boolean;
  @Input() jdSearchPlaceholder: string;
  @Input() jdNotFoundContent: string;

  // events
  @Output() jdChange: EventEmitter<TransferChange> = new EventEmitter();
  @Output() jdSearchChange: EventEmitter<TransferSearchChange> = new EventEmitter();
  @Output() jdSelectChange: EventEmitter<TransferSelectChange> = new EventEmitter();
  @Input() jdCanMove: (arg: TransferCanMove) => Observable<TransferItem[]> = (arg: TransferCanMove) => of(arg.list);

  // search
  @Input()
  set jdShowSearch(value: boolean) {
    this._showSearch = toBoolean(value);
  }

  get jdShowSearch(): boolean {
    return this._showSearch;
  }


  private splitDataSource(): void {
    this.leftDataSource = [];
    this.rightDataSource = [];
    this.jdDataSource.forEach(record => {
      if (record.direction === 'right') {
        this.rightDataSource.push(record);
      } else {
        this.leftDataSource.push(record);
      }
    });
  }

  private getCheckedData(direction: string): TransferItem[] {
    return this[direction === 'left' ? 'leftDataSource' : 'rightDataSource'].filter(w => w.checked);
  }

  handleLeftSelectAll = (checked: boolean) => this.handleSelect('left', checked);
  handleRightSelectAll = (checked: boolean) => this.handleSelect('right', checked);

  handleLeftSelect = (item: TransferItem) => this.handleSelect('left', item.checked, item);
  handleRightSelect = (item: TransferItem) => this.handleSelect('right', item.checked, item);

  handleSelect(direction: 'left' | 'right', checked: boolean, item?: TransferItem): void {
    const list = this.getCheckedData(direction);
    this.updateOperationStatus(direction, list.length);
    this.jdSelectChange.emit({direction, checked, list, item});
  }

  handleFilterChange(ret: { direction: string, value: string }): void {
    this.jdSearchChange.emit(ret);
  }

  // endregion

  // region: operation


  private updateOperationStatus(direction: string, count?: number): void {
    this[direction === 'right' ? 'leftActive' : 'rightActive'] = (typeof count === 'undefined' ? this.getCheckedData(direction).filter(w => !w.disabled).length : count) > 0;
  }

  moveToLeft = () => this.moveTo('left');
  moveToRight = () => this.moveTo('right');

  moveTo(direction: string): void {
    const oppositeDirection = direction === 'left' ? 'right' : 'left';
    this.updateOperationStatus(oppositeDirection, 0);
    const datasource = direction === 'left' ? this.rightDataSource : this.leftDataSource;
    const moveList = datasource.filter(item => item.checked === true && !item.disabled);
    this.jdCanMove({direction, list: moveList})
      .subscribe(
        newMoveList => this.truthMoveTo(direction, newMoveList.filter(i => !!i)),
        () => moveList.forEach(i => i.checked = false)
      );
  }

  private truthMoveTo(direction: string, list: TransferItem[]): void {
    const oppositeDirection = direction === 'left' ? 'right' : 'left';
    const datasource = direction === 'left' ? this.rightDataSource : this.leftDataSource;
    const targetDatasource = direction === 'left' ? this.leftDataSource : this.rightDataSource;
    for (const item of list) {
      item.checked = false;
      targetDatasource.push(item);
      datasource.splice(datasource.indexOf(item), 1);
    }
    this.updateOperationStatus(oppositeDirection);
    this.jdChange.emit({
      from: oppositeDirection,
      to: direction,
      list
    });
  }

  // endregion

  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('jdDataSource' in changes) {
      this.splitDataSource();
      this.updateOperationStatus('left');
      this.updateOperationStatus('right');
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
